import affliction from './affliction'
import demonology from './demonology'
import destruction from './destruction'

const warlock = { specs: [affliction, demonology, destruction] }

export default warlock
